// extracted by mini-css-extract-plugin
export default {"genvite":"Genvite_genvite__tDlf+","landing":"Genvite_landing__eEtAC","sec":"Genvite_sec__IYK2G","imgSec":"Genvite_imgSec__PlGSN","videoTitle":"Genvite_videoTitle__SbIV5"};